module.exports = __webpack_public_path__ + "static/img/bg_jp.4f91eb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hlSaled-2025/bg_jp.png
// module id = 9OWX
// module chunks = 1